import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Spinner,
  FormGroup,
  Badge,
} from "reactstrap"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import { debounce, map, range } from "lodash"

import ToolkitProvider from "react-bootstrap-table2-toolkit"
import Select from "react-select"

import "../../assets/scss/datatables.scss"

import MyPagination from "components/Common/MyPagination"
import DeleteModal from "components/Common/DeleteModal"
import {
  getAllDistricts,
  getAllLsgs,
  getAllStates,
  getAllTaluks,
  getPromoters,
  updatePromoter,
  deletePromoter,
} from "store/actions"
import { AvField, AvForm } from "availity-reactstrap-validation"

const Promoters = () => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)
  const [sort, setSort] = useState("all")
  const [totalItemLimit, setTotalItemLimit] = useState(10)

  const [stateSearch, setStateSearch] = useState("")
  const [stateSelect, setStateSelect] = useState(null)
  const [stateSelectId, setStateSelectId] = useState("")

  const [districtSearch, setDistrictSearch] = useState("")
  const [districtSelect, setDistrictSelect] = useState(null)
  const [districtSelectId, setDistrictSelectId] = useState("")

  const [talukSearch, setTalukSearch] = useState("")
  const [talukSelect, setTalukSelect] = useState(null)
  const [talukSelectId, setTalukSelectId] = useState("")

  const [lsgSearch, setLsgSearch] = useState("")
  const [lsgSelect, setLsgSelect] = useState(null)
  const [lsgSelectId, setLsgSelectId] = useState("")

  const { allPromoters, loading, taluks, districts, states, lsgs } =
    useSelector(state => ({
      allPromoters: state?.Users?.promotersList,
      loading: state.Users?.promoterLoad,
      states: state.Location.states,
      districts: state.Location.districts,
      taluks: state.Location.taluks,
      lsgs: state.Location.lsgs,
    }))

  const [searchText, setSearchText] = useState("")

  const debouncePromoterSearch = debounce(value => {
    setSearchText(value)
    setPage(1)
  }, 600)

  // delete modal
  const [isOpen, setIsOpen] = useState({ stauts: false, id: "" })
  const handleDeleteEvent = () => {
    setIsOpen({ ...isOpen, stauts: false })
    dispatch(
      deletePromoter(isOpen?.id, {
        goBack: () => {
          dispatch(
            getPromoters(
              page,
              searchText,
              sort,
              totalItemLimit,
              stateSelectId,
              districtSelectId,
              talukSelectId,
              lsgSelectId
            )
          )
        },
      })
    )
  }
  const handleDelete = id => {
    setIsOpen({ stauts: true, id: id })
  }

  useEffect(() => {
    dispatch(
      getPromoters(
        page,
        searchText,
        sort,
        totalItemLimit,
        stateSelectId,
        districtSelectId,
        talukSelectId,
        lsgSelectId
      )
    )
  }, [
    dispatch,
    page,
    searchText,
    sort,
    totalItemLimit,
    stateSelectId,
    districtSelectId,
    talukSelectId,
    lsgSelectId,
  ])

  const totalPages = Math.ceil(
    (allPromoters?.total || 0) / Number(totalItemLimit || 10)
  )
  const pages = range(1, totalPages + 1)

  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "phone",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "ref_id",
      text: "Referral Id",
      sort: true,
    },
    {
      dataField: "promoterPercentage",
      text: "Promoter %",
      sort: true,
    },
    {
      dataField: "approvalData",
      text: "Approval",
    },
    {
      dataField: "activeData",
      text: "Status",
      sort: true,
    },
    {
      dataField: "action",
      text: "Action",
    },
  ]

  const handleSwitchChange = (e, item) => {
    const finalData = {
      ...item,
      isActive: e.target.checked,
    }

    dispatch(updatePromoter(finalData, item?._id))
  }

  const promoterData = map(allPromoters?.promoters || [], (item, index) => ({
    ...item,
    name: item?.name || <span className="text-muted">Not provided</span>,
    phone: item?.phone || <span className="text-muted">Not provided</span>,
    ref_id: item?.ref_id || <span className="text-muted">Not assigned</span>,
    promoterPercentage: (
      <span>
        {Number.isFinite(item?.promoterPercentage)
          ? item.promoterPercentage
          : 0}
        %
      </span>
    ),
    approvalData: (
      <Badge
        className={
          item?.isVerified
            ? "font-size-12 badge-soft-success"
            : "font-size-12 badge-soft-warning"
        }
        pill
      >
        {item?.isVerified ? "Approved" : "Unapproved"}
      </Badge>
    ),
    activeData: (
      <div className="form-check form-switch form-switch-md mb-3">
        <input
          type="checkbox"
          className="form-check-input"
          id={`customSwitchsizemd-${item?._id || index}`}
          onChange={e => {
            handleSwitchChange(e, item)
          }}
          checked={item?.isActive}
        />
        <label
          className="form-check-label"
          htmlFor={`customSwitchsizemd-${item?._id || index}`}
        >
          {item?.isActive ? `Active` : `Inactive`}
        </label>
      </div>
    ),
    action: (
      <div>
        <Link to={`promoter/${item?._id}`}>
          <Button
            id={`view${index}`}
            type="button"
            color="white"
            className="ms-1 btn"
          >
            <i
              className="bx bx-show-alt me-2"
              style={{ color: "green", fontSize: "22px" }}
            />
          </Button>
        </Link>
        <Button
          id={`delete${index}`}
          type="button"
          color="white"
          className="ms-1 btn "
          onClick={() => {
            handleDelete(item?._id)
          }}
        >
          <i
            className="bx bx-trash me-2"
            style={{ color: "red", fontSize: "20px" }}
          />
        </Button>
      </div>
    ),
  }))

  useEffect(() => {
    const currentLimit = sessionStorage.getItem("promoterLimit")
    if (currentLimit) {
      setTotalItemLimit(parseInt(currentLimit, 10))
    }
  }, [])

  const handlePageLimit = e => {
    if (e.target.value >= 1) {
      setTotalItemLimit(parseInt(e.target.value, 10))
      sessionStorage.setItem("promoterLimit", e.target.value)
      setPage(1)
    }
  }

  const listChange = sortValue => {
    setSort(sortValue)
    setPage(1)
  }

  useEffect(() => {
    dispatch(getAllStates(stateSearch, 1, 20))
  }, [dispatch, stateSearch])
  const debounceStateSearch = debounce(value => setStateSearch(value), 600)
  const handleStateEnters = textEntered => {
    debounceStateSearch(textEntered)
  }
  function handlerStateFinalValue(event) {
    setStateSelect(event || null)
    setStateSelectId(event?.value || "")
    setDistrictSelect(null)
    setDistrictSelectId("")
    setTalukSelect(null)
    setTalukSelectId("")
    setLsgSelect(null)
    setLsgSelectId("")
    setPage(1)
  }
  const StateOptions = [
    {
      label: "All states",
      value: "",
    },
    {
      label: "States",
      options: (states?.total >= 1 ? states?.states : [])?.map(
        (result, index) => ({
          key: index,
          label: result?.name,
          value: result?._id,
        })
      ),
    },
  ]

  useEffect(() => {
    dispatch(getAllDistricts(districtSearch, stateSelectId, 1, 20))
  }, [dispatch, districtSearch, stateSelectId])
  const debounceDistrictSearch = debounce(
    value => setDistrictSearch(value),
    600
  )
  const handleDistrictEnters = textEntered => {
    debounceDistrictSearch(textEntered)
  }
  function handlerDistrictFinalValue(event) {
    setDistrictSelect(event || null)
    setDistrictSelectId(event?.value || "")
    setTalukSelect(null)
    setTalukSelectId("")
    setLsgSelect(null)
    setLsgSelectId("")
    setPage(1)
  }
  const DistrictOptions = [
    {
      label: "All districts",
      value: "",
    },
    {
      label: "Districts",
      options: (districts?.total >= 1 ? districts?.districts : [])?.map(
        (result, index) => ({
          key: index,
          label: result?.name,
          value: result?._id,
        })
      ),
    },
  ]

  useEffect(() => {
    dispatch(getAllTaluks(talukSearch, districtSelectId, 1, 20))
  }, [dispatch, talukSearch, districtSelectId])
  const debounceTalukSearch = debounce(value => setTalukSearch(value), 600)
  const handleTalukEnters = textEntered => {
    debounceTalukSearch(textEntered)
  }
  function handlerTalukFinalValue(event) {
    setTalukSelect(event || null)
    setTalukSelectId(event?.value || "")
    setPage(1)
  }
  const talukOptions = [
    {
      label: "All Taluks",
      value: "",
    },
    {
      label: "Taluks",
      options:
        taluks &&
        taluks?.total >= 1 &&
        taluks?.taluks?.map((result, index) => ({
          key: index,
          label: result?.name,
          value: result._id,
        })),
    },
  ]

  useEffect(() => {
    dispatch(getAllLsgs(lsgSearch, districtSelectId, 1, 20))
  }, [dispatch, lsgSearch, districtSelectId])
  const debounceLsgSearch = debounce(value => setLsgSearch(value), 600)
  const handleLsgEnters = textEntered => {
    debounceLsgSearch(textEntered)
  }
  function handlerLsgFinalValue(event) {
    setLsgSelect(event || null)
    setLsgSelectId(event?.value || "")
    setPage(1)
  }
  const lsgOptions = [
    {
      label: "All local bodies",
      value: "",
    },
    {
      label: "Local bodies",
      options:
        lsgs &&
        lsgs?.total >= 1 &&
        lsgs?.lsgs?.map((result, index) => ({
          key: index,
          label: result?.name,
          value: result._id,
        })),
    },
  ]

  return (
    <React.Fragment>
      <DeleteModal
        show={isOpen?.stauts}
        onCloseClick={() => setIsOpen({ ...isOpen, stauts: false })}
        onDeleteClick={handleDeleteEvent}
      />
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <Row className="align-items-center mb-3">
                <Col md="9" className="mb-3 mb-md-0">
                  <div
                    className="btn-group mt-2 mt-xl-0"
                    role="group"
                    aria-label="Basic radio toggle button group"
                  >
                    <input
                      type="radio"
                      className="btn-check"
                      name="promoterbtnradio"
                      id="allpromoterbtnradio"
                      autoComplete="off"
                      checked={sort === "all"}
                      onChange={() => listChange("all")}
                    />
                    <label
                      className="btn btn-success"
                      htmlFor="allpromoterbtnradio"
                    >
                      All
                    </label>

                    <input
                      type="radio"
                      className="btn-check"
                      name="promoterbtnradio"
                      id="approvedpromoterbtnradio"
                      autoComplete="off"
                      checked={sort === "approved"}
                      onChange={() => listChange("approved")}
                    />
                    <label
                      className="btn btn-success"
                      htmlFor="approvedpromoterbtnradio"
                    >
                      Approved
                    </label>

                    <input
                      type="radio"
                      className="btn-check"
                      name="promoterbtnradio"
                      id="unapprovedpromoterbtnradio"
                      autoComplete="off"
                      checked={sort === "unapproved"}
                      onChange={() => listChange("unapproved")}
                    />
                    <label
                      className="btn btn-success"
                      htmlFor="unapprovedpromoterbtnradio"
                    >
                      Unapproved
                    </label>

                    <input
                      type="radio"
                      className="btn-check"
                      name="promoterbtnradio"
                      id="activepromoterbtnradio"
                      autoComplete="off"
                      checked={sort === "active"}
                      onChange={() => listChange("active")}
                    />
                    <label
                      className="btn btn-success"
                      htmlFor="activepromoterbtnradio"
                    >
                      Active
                    </label>

                    <input
                      type="radio"
                      className="btn-check"
                      name="promoterbtnradio"
                      id="inactivepromoterbtnradio"
                      autoComplete="off"
                      checked={sort === "inactive"}
                      onChange={() => listChange("inactive")}
                    />
                    <label
                      className="btn btn-success"
                      htmlFor="inactivepromoterbtnradio"
                    >
                      Inactive
                    </label>
                  </div>
                </Col>
                <Col md="3" className="text-md-end">
                  <Link to="/promoter/create/new">
                    <Button
                      type="button"
                      color="success"
                      className="mt-2 mt-xl-0"
                    >
                      <i className="bx bx-plus me-1" />
                      Create Promoter
                    </Button>
                  </Link>
                </Col>
              </Row>

              <div>
                <ToolkitProvider
                  keyField="_id"
                  columns={columns}
                  data={promoterData}
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <Row className="mb-2">
                        <Col sm="4">
                          <div className="search-box mb-2 d-inline-block">
                            <div className="position-relative">
                              <AvForm>
                                <AvField
                                  name="searchText"
                                  placeholder="Search"
                                  type="text"
                                  onChange={e =>
                                    debouncePromoterSearch(e.target.value)
                                  }
                                />
                              </AvForm>
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                        <Col sm="4">
                          <AvForm className="form-horizontal mx-2 mb-3 d-flex align-items-center">
                            <div className="mx-1">
                              <span className="">
                                Show
                                <i className="fas fa-sort-numeric-down-alt mx-1"></i>
                              </span>
                            </div>
                            <div className="" style={{ width: "50px" }}>
                              <AvField
                                name="pageLimit"
                                className="form-control"
                                value={totalItemLimit}
                                onChange={e => handlePageLimit(e)}
                                type="text"
                                required
                              />
                            </div>
                          </AvForm>
                        </Col>
                      </Row>
                      <Row className="mb-2">
                        <Col className="mb-2" md={6} xl={3}>
                          <FormGroup className="mb-0">
                            <div className="ajax-select mt-lg-0 select2-container">
                              <Select
                                onInputChange={handleStateEnters}
                                value={stateSelect}
                                placeholder="All states"
                                onChange={handlerStateFinalValue}
                                options={StateOptions}
                                classNamePrefix="select2-selection"
                                isLoading={loading}
                                isClearable
                              />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col className="mb-2" md={6} xl={3}>
                          <FormGroup className="mb-0">
                            <div className="ajax-select mt-lg-0 select2-container">
                              <Select
                                onInputChange={handleDistrictEnters}
                                value={districtSelect}
                                placeholder="All districts"
                                onChange={handlerDistrictFinalValue}
                                options={DistrictOptions}
                                classNamePrefix="select2-selection"
                                isLoading={loading}
                                isClearable
                              />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col className="mb-2" md={6} xl={3}>
                          <FormGroup className="mb-0">
                            <div className="ajax-select mt-lg-0 select2-container">
                              <Select
                                onInputChange={handleTalukEnters}
                                value={talukSelect}
                                placeholder="All taluks"
                                onChange={handlerTalukFinalValue}
                                options={talukOptions}
                                classNamePrefix="select2-selection"
                                isLoading={loading}
                                isClearable
                              />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col className="mb-2" md={6} xl={3}>
                          <FormGroup className="mb-0">
                            <div className="ajax-select mt-lg-0 select2-container">
                              <Select
                                onInputChange={handleLsgEnters}
                                value={lsgSelect}
                                placeholder="All local bodies"
                                onChange={handlerLsgFinalValue}
                                options={lsgOptions}
                                classNamePrefix="select2-selection"
                                isLoading={loading}
                                isClearable
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      {loading ? (
                        <Spinner color="secondary" className="d-block m-auto" />
                      ) : (
                        <>
                          {allPromoters?.promoters?.length ? (
                            <Row>
                              <p>Total Promoters : {allPromoters?.total || 0}</p>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    key={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          ) : (
                            <p
                              className="my-4 mx-3 "
                              style={{ textTransform: "capitalize" }}
                            >
                              No {sort === "all" ? "Promoter" : sort}s!
                            </p>
                          )}
                          <MyPagination
                            totalPages={pages}
                            page={page}
                            setPage={setPage}
                          />
                        </>
                      )}
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Promoters
